import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private service: AuthenticationService, private router: Router) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const rolIsCorrect = await this.service.rolIsOkey();
    if (this.service.isUserLoggedIn() && rolIsCorrect) {
      return true;
    }
    else {
      this.router.navigate(["/login"]);

      return false;
    }
  }


}
